import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useCarsGroupsStore = defineStore('carsGroups', () => {
  
    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()

    const carsGroups = ref({})
    const carsGroupsProcess = ref(false)
    const carsGroupsMsg = ref({})

    const carsGroup = ref({})
    const carsGroupProcess = ref(false)
    const carsGroupMsg = ref({})

    const carsGroupsCreateProcess = ref(false)
    const carsGroupsCreateMsg = ref({})

    const carsGroupsUpdateProcess = ref(false)
    const carsGroupsUpdateMsg = ref({})

    const carsGroupsDeleteProcess = ref(false)
    const carsGroupsDeleteMsg = ref({})

    async function createCarsGroup(payload) {

        carsGroupsCreateProcess.value = true
        const token = tokenStore.access

        if(token) {
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups`, 
                method: 'POST', 
                token,
                data: payload
            })
            if(!request.error) {
                carsGroupsCreateMsg.value = { success: true, text: 'CARS_GROUPS_CREATE_SUCCESS' }
            } else {
                carsGroupsCreateMsg.value = { success: false, text: request.error }
            }
        } else {
            carsGroupsCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carsGroupsCreateProcess.value = false
    }

    async function readCarsGroup(payload) {

        carsGroupProcess.value = true
        const token = tokenStore.access

        if(token) {
            let params = ''
            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups${params}`, 
                method: 'GET', 
                token
            })
            if(!request.error) {
                carsGroup.value = request.array[0]
                carsGroupMsg.value = { success: true }
            } else {
                carsGroup.value = {}
                carsGroupMsg.value = { success: false, text: request.error}
            }
        } else {
            carsGroupMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carsGroupProcess.value = false
        return carsGroup.value
    }

    async function readCarsGroups(payload) {

        carsGroupsProcess.value = true
        const token = tokenStore.access

        if(token) {
            let params = ''
            if(payload) {
                for( let param in payload) {
                    if(Array.isArray(payload[param])) {
                        payload[param].map(item => {
                            params.length ?
                                params += '&' + param + '=' + item :
                                params = '?' + param + '=' + item
                        })
                    } else {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups${params}`, 
                method: 'GET', 
                token
            })
            if(!request.error) {
                carsGroups.value = request
                carsGroupsMsg.value = { success: true, text: '' }
            } else {
                carsGroups.value = {}
                carsGroupsMsg.value = { success: false, text: request.error }
            }
        } else {
            carsGroupsMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carsGroupsProcess.value = false
        return carsGroups.value
    }

    async function updateCarsGroups(payload) {

        carsGroupsUpdateProcess.value = true
        const token = tokenStore.access

        if(token) {
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups`, 
                method: 'PUT', 
                token,
                data: payload
            })
            if(!request.error) {
                carsGroupsUpdateMsg.value = { success: true, text: 'CARS_GROUP_UPDATE_SUCCESS' }
            } else {
                carsGroupsUpdateMsg.value = { success: false, text: request.error }
            }
        } else {
            carsGroupsUpdateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carsGroupsUpdateProcess.value = false
    }

    async function deleteCarsGroups(payload) {

        carsGroupsDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cgroups/${payload}`, 
                method: 'DELETE', 
                token
            })
            if(!request.error) {
                carsGroupsDeleteMsg.value = { success: true, text: 'CARS_GROUPS_DELETE_SUCCESS' }
            } else {
                carsGroupsDeleteMsg.value = { success: false, text: request.error }
            }
        } else {
            carsGroupsDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carsGroupsDeleteProcess.value = false
    }

    const setCarsGroups             = data => carsGroups.value            = data
    const setCarsGroupsCreateMsg    = data => carsGroupsCreateMsg.value   = data
    const setCarsGroupsUpdateMsg    = data => carsGroupsUpdateMsg.value   = data
    const setCarsGroupsDeleteMsg    = data => carsGroupsDeleteMsg.value   = data

    return {

        carsGroups, 
        carsGroupsProcess, 
        carsGroupsMsg, 
        carsGroup, 
        carsGroupProcess, 
        carsGroupMsg, 
        carsGroupsCreateProcess, 
        carsGroupsCreateMsg, 
        carsGroupsUpdateProcess, 
        carsGroupsUpdateMsg, 
        carsGroupsDeleteProcess, 
        carsGroupsDeleteMsg, 
        createCarsGroup, 
        readCarsGroup, 
        readCarsGroups, 
        updateCarsGroups, 
        deleteCarsGroups, 
        setCarsGroups, 
        setCarsGroupsCreateMsg,
        setCarsGroupsUpdateMsg,
        setCarsGroupsDeleteMsg
    }
})